import React from "react";
import { CheckIcon, GlobeIcon, LockIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { images } from "../../data/links";
const included = [{
  label: "Mastopexy Surgical Blueprint™ — 6 Premium Volumes",
  value: "$97"
}, {
  label: "5 Professional Bonuses",
  value: "$197"
}];
const perks = ["Lifetime digital access", "Instant download", "No monthly subscription", "No recurring fees", "7-day guarantee"];
export function Offer() {
  return <section id="offer" className="bg-cream px-4 py-16 sm:py-24" data-id="element-250" data-mp="3jv8hl8cun7pc">
      <div className="mx-auto max-w-2xl" data-id="element-251" data-mp="3jw1t0mmr6ldt">
        <p className="text-center text-sm font-extrabold uppercase tracking-wide text-alert" data-id="element-252" data-mp="3nwlntjjutcws">Special launch offer</p>
        <h2 className="text-balance mt-3 text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-253" data-mp="3swpz8v5wnhg5">
          Here's everything you'll receive <em className="text-gold" data-id="element-254" data-mp="1naqvss4v4tx">today</em>
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white shadow-[0_20px_60px_rgba(14,26,51,0.14)] ring-2 ring-gold/40" data-id="element-255" data-mp="1km9kmzrjfzrz">
          <div className="bg-cream" data-id="element-256" data-mp="1foht46ut2fob">
            <img src={images.mockup} alt="Everything included in Mastopexy Surgical Blueprint" className="w-full mix-blend-multiply" data-id="element-257" data-mp="1bka1a0t1wjlv" />
          </div>

          <div className="px-5 pb-8 pt-6 sm:px-10" data-id="element-258" data-mp="16njllel5rq0z">
            <ul className="divide-y divide-navy/10" data-id="element-259" data-mp="23chltcbogg5j">
              {included.map(i => <li key={i.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-260" data-mp="1z9umyrgl9uyu">
                  <span className="text-[16px] font-semibold leading-snug text-ink" data-id="element-261" data-mp="1ujeab9kleddj">{i.label}</span>
                  <span className="shrink-0 text-[16px] font-bold text-ink/50 line-through" data-id="element-262" data-mp="1pktavcd5zxq5">{i.value}</span>
                </li>)}
              <li className="flex items-center justify-between gap-4 py-3.5" data-id="element-263" data-mp="2n1i6upffo5rm">
                <span className="text-[16px] font-extrabold uppercase text-ink" data-id="element-264" data-mp="2i878lcoosxbb">Total value</span>
                <span className="shrink-0 text-xl font-extrabold text-alert line-through" data-id="element-265" data-mp="316igqdi6wadc">$294</span>
              </li>
            </ul>

            <div className="mt-6 text-center" data-id="element-266" data-mp="363sj0tqoggil">
              <p className="text-[16px] text-ink/70" data-id="element-267" data-mp="2sdowe1nvyksm">But today, the complete Mastopexy Surgical Blueprint™ is available for:</p>
              <p className="mt-2 font-serif text-[88px] font-extrabold leading-none text-cta sm:text-[112px]" data-id="element-268" data-mp="2wdfvqtrha98r">
                $27
              </p>
              <p className="mt-1 text-sm font-extrabold uppercase tracking-widest text-navy" data-id="element-269" data-mp="2ne2mo279nmok">One-time payment · USD</p>
            </div>

            <p className="mx-auto mt-5 flex max-w-md items-start justify-center gap-2 rounded-xl bg-navy/5 px-4 py-3 text-left text-sm leading-snug text-navy" data-id="element-270" data-mp="29fco0i4stey3">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" data-id="element-271" data-mp="7my81oltekkb" />
              <span data-id="element-272" data-mp="7l3nibeggugr">
                <strong data-id="element-273" data-mp="bo9rtdi0cbkl">Automatic currency conversion:</strong> the price is shown in your local currency at checkout.
              </span>
            </p>

            <ul className="mt-6 grid gap-2 sm:grid-cols-2" data-id="element-274" data-mp="1w73v8tgml23h">
              {perks.map(p => <li key={p} className="flex items-center gap-2.5 text-[16px] font-medium text-ink" data-id="element-275" data-mp="1s6jwjlgelqf8">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-276" data-mp="25xyia01p45pz">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-277" data-mp="213killg03cfi" />
                  </span>
                  {p}
                </li>)}
            </ul>

            <div className="mt-6" data-id="element-278" data-mp="2axkse0m895uk">
              <ScarcityBar data-id="element-279" data-mp="2ouzlpgflpxrt" />
            </div>

            <div className="mt-6" data-id="element-280" data-mp="2oupvpsuk3qm4">
              <CTAButton label="Get Mastopexy Surgical Blueprint™" data-id="element-281" data-mp="2jw54uk172jac" />
              <p className="mt-3 flex items-center justify-center gap-1.5 text-sm text-ink/60" data-id="element-282" data-mp="2jwy30wm380gv">
                <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-283" data-mp="uhgtmm4cb7dw" />
                Secure checkout · Instant digital access · 7-day guarantee
              </p>
            </div>

            <Countdown caption="Get access to the current promotional price while it is available." data-id="element-284" data-mp="rvr01x86jtiw" />

            <p className="mt-6 text-center text-[15px] leading-relaxed text-ink/70" data-id="element-285" data-mp="vx2pa1n56cqk">
              For less than the cost of many professional educational resources, you get a complete structured system
              you can return to whenever you review a mastopexy case.
            </p>
          </div>
        </div>
      </div>
    </section>;
}